import { useEffect, useState } from 'react'

export type Route =
  | 'home'
  | 'pricing'
  | 'additionalCosts'
  | 'contact'
  | 'industries'
  | 'crm'
  | 'websites'
  | 'gallery'
  | 'partners'

function readRoute(): Route {
  const hash = window.location.hash
  if (hash.startsWith('#/pricing/additional-costs')) return 'additionalCosts'
  if (hash.startsWith('#/pricing')) return 'pricing'
  if (hash.startsWith('#/industries')) return 'industries'
  if (hash.startsWith('#/crm')) return 'crm'
  if (hash.startsWith('#/design/gallery')) return 'gallery'
  if (hash.startsWith('#/design')) return 'websites'
  if (hash.startsWith('#/contact')) return 'contact'
  if (hash.startsWith('#/partners')) return 'partners'
  return 'home'
}

export function useHashRoute(): Route {
  const [route, setRoute] = useState<Route>(readRoute)

  useEffect(() => {
    const handleHashChange = () => {
      const next = readRoute()
      setRoute((prev) => {
        if (prev !== next) window.scrollTo({ top: 0 })
        return next
      })
    }
    window.addEventListener('hashchange', handleHashChange)
    return () => window.removeEventListener('hashchange', handleHashChange)
  }, [])

  return route
}
